<template>
  <b-container fluid>
    <b-row>
      <b-col class="bg-white py-1">
        <span v-translate="{totalRows: pickedupShippings.length}">
          Total items: <strong>%{totalRows}</strong>
        </span>
        <a href="#" @click.prevent="copyToClipboard(pickedupShippings.map(x => { return x.id }).join('\n'), $gettext('Picked Up IDs'))" class="text-secondary" :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
      </b-col>
      <b-col class="text-right mb-3">
        <b-button size="sm" variant="primary" target="_blank" :disabled="pickedupShippings.length === 0" :href="'/shippings/list?qf=%7B%22pickup-shipping%22%3A%22' + shippingId + '%22%7D'" v-translate>
          Open in Shipment List
        </b-button>
      </b-col>
    </b-row>
    <b-table striped
      :items="pickedupShippings"
      :fields="pickedupShippingsFields"
      empty-text="There are no picked up shippings to show yet"
      show-empty
    >
      <template v-slot:cell(id)="data">
        <b-link :to="{name: 'ShippingsEdit', params: {id: data.value}}">{{data.value | uuid }}</b-link>
        <a href="#" @click.prevent="copyToClipboard(data.value)" class="text-secondary" :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
        <div v-if="data.item.platform_id">
          <span class="badge" :style="'background-color: ' + stringToColour(' ' + data.item.platform_id + data.item.platform_id + data.item.platform_id + data.item.platform_id) + ';' + textContrastColor(stringToColour(' ' + data.item.platform_id + data.item.platform_id + data.item.platform_id + data.item.platform_id))">{{platforms.find(x => x.id === data.item.platform_id).name}}</span>
        </div>
      </template>
      <template v-slot:cell(company_id)="row">
        <div v-if="row.item.company">
          <b-badge variant="dark" v-translate>Company</b-badge>
          <company-card :company="row.item.company" :profilePicture="false" :withContact="false" />
        </div>
        <div v-else>
          <b-badge variant="dark" v-translate>Shared</b-badge>
          <img src="/static/img/moova-blue.svg" class="d-block mt-1" style="max-width: 100px;" :alt="$gettext('Shared')">
        </div>
      </template>
      <template v-slot:cell(size_id)="row">
        {{shippingSizes.find(x => x.id === row.item.size_id) ? shippingSizes.find(x => x.id === row.item.size_id).name : ''}}
      </template>
      <template v-slot:cell(shipping_type_id)="row">
        {{shippingTypes.find(x => x.value === row.item.shipping_type_id) ? shippingTypes.find(x => x.value === row.item.shipping_type_id).text : ''}}
      </template>
    </b-table>
  </b-container>
</template>

<script>
import {
  ShippingService
} from '@/services/api'

export default {
  name: 'ShippingPickedupShippings',
  props: {
    shippingId: {
      type: String,
      default: '',
      required: true
    }
  },
  data() {
    return {
      pickedupShippings: [],
      pickedupShippingsFields: [
        {
          key: 'id',
          label: this.$gettext('ID')
        },
        {
          key: 'company_id',
          label: this.$gettext('Company')
        },
        {
          key: 'status',
          label: this.$gettext('Status')
        },
        {
          key: 'size_id',
          label: this.$gettext('Size')
        },
        {
          key: 'shipping_type_id',
          label: this.$gettext('Type')
        }
      ]
    }
  },
  mounted () {
    this.getPickedupShippings()
  },
  methods: {
    getPickedupShippings() {
      const params = {
        includes: [
          'pickedupShippings.company'
        ]
      }
      ShippingService.get(this.shippingId, { params })
        .then(response => {
          this.pickedupShippings = response.body.pickedup_shippings
        })
    }
  }
}
</script>
